import { doc, getFirestore } from 'firebase/firestore';
import useRealtimeDoc from 'hooks/use-realtimeDoc';
import { useMemo } from 'react';

/**
 * Subscribes to a single test_stand_logs document in real time.
 * Returns `{ data, status }` — data is null when id is falsy.
 */
export default function useActiveTestLog(id) {
  const docRef = useMemo(
    () => (id ? doc(getFirestore(), 'test_stand_logs', id) : null),
    [id],
  );
  return useRealtimeDoc({ docRef });
}
